import { render, staticRenderFns } from "./FilterMenu.vue?vue&type=template&id=0816d1ce"
import script from "./FilterMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterMenu.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports